export const formInputClassName =
  "flex h-8 w-full items-center rounded border border-solid border-neutral-200 bg-white px-2 py-1 text-xs font-bold text-black-900 text-opacity-60 outline-none focus:ring-2 focus:border-sky-200 focus:ring-sky-200 sm:h-10 sm:px-3 sm:text-sm placeholder:text-black-900/40";

export const formLabelClassName =
  "mb-0.5 block text-[11px] font-bold leading-none text-white sm:text-sm";
